import React, { useState } from 'react';
import Header from '../componets/Header';
import Footer from '../componets/Footer';


const data = [
  {
    'District': 'Agar-Malwa',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Alirajpur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Anuppur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Ashoknagar',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Balaghat',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Barwani',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Betul',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Bhopal',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Burhanpur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Chhindwara',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Chhatarpur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Dewas',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Dindori',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Guna',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Gwalior',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Harda',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Hoshangabad',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Indore',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Jabalpur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Jhabua',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Katni',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Khandwa',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Khargone',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Mandla',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Mandsaur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Morena',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Narsinghpur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Neemuch',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Pachora',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Pandhurna',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Panna',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Raisen',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Rajgarh',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Ratlam',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Rewa',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Sagar',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Satna',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Sehore',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Seoni',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Shahdol',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Shajapur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Sheopur',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Shivpuri',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Sidhi',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Singrauli',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Tikamgarh',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Ujjain',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Umaria',
    'map': "img/malw-aager.svg"
  },
  {
    'District': 'Vidisha',
    'map': "img/malw-aager.svg"
  },
];

function CitizenLogin() {
  // State to store the search query, filtered results, and pagination
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState(data);
  const [currentPage, setCurrentPage] = useState(1);
  const [noResultsMessage, setNoResultsMessage] = useState('');
  const itemsPerPage = 10;

  // Function to handle the search input change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  // Function to handle the search button click
  const handleSearchClick = () => {
    const filtered = data.filter(item =>
      item.District.toLowerCase().includes(searchQuery.toLowerCase())
    );
    if (!filtered || filtered.length === 0) {
      setNoResultsMessage("No results found.");
      setFilteredData([]);
    } else {
      setNoResultsMessage(''); // Clear the message if results are found
      setFilteredData(filtered);
      console.log("result", filtered);
    }
  
    setCurrentPage(1);
  };

  // Function to handle "Show More" button click
  const handleShowMore = () => {
    setCurrentPage(currentPage + 1);
  };

  // Calculate the districts to be displayed based on current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentDistricts = filteredData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>
      <Header />
      <div style={{ padding: '20px' }}>
        <div style={{ position: 'relative', width: '100%', maxWidth: '400px', margin: 'auto' }} className='citizen-container'>
          <input
            type="text"
            placeholder="Search district"
            value={searchQuery}
            onChange={handleSearch}
            className='form-control'
            style={{
              width: '100%',
              padding: '10px',
              paddingRight: '80px', // Space for the button
              borderRadius: '5px',
              border: '1px solid #ccc',
              borderRadius: '30px',
            }}
          />
          <button
            onClick={handleSearchClick}
            style={{
              position: 'absolute',
              top: '50%',
              right: '2px',
              transform: 'translateY(-50%)',
              padding: '10px 16px',
              borderRadius: '0 30px 30px 0',
              backgroundColor: '#007BFF',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}

          >
            <img src="img/Vectorsearch.png" alt='search' />
          </button>
        </div>


        {/* Display filtered districts in card format */}
        <div style={{ marginTop: '20px' }}>
          <div className="row justify-content-center cardRow">
            {currentDistricts.map((item, index) => (
              <div
                key={index}
                className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 p-0 card-container" // Adjust column size for 5 per row
                style={{
                  marginBottom: '20px', // Add spacing between rows
                  display: 'flex', // Flexbox ensures equal height
                  justifyContent: 'center', // Center content horizontally
                }}
              >
                <div
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: '18px',
                    textAlign: 'center',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.3s ease',
                  }}
                >
                  <div
                    className='mapimgsearch' >
                  <img src={item.map} alt="images" style={{ maxWidth: '100%', height: 'auto', borderRadius: '4px' }}
                
                  />
                  </div>
                  <div className='districtdiv'>
                  <h3 className='m-0'>{item.District}</h3>
                  <button className="view-btn">View more</button>
                  </div>
                </div>
              </div>
            ))}
            {noResultsMessage && <p>{noResultsMessage}</p>}

          </div>
        </div>


        {/* Show More button */}
        {filteredData.length > currentPage * itemsPerPage && (
          <div className='d-flex justify-content-center'>
          <button
            onClick={handleShowMore}
            style={{
              padding: '10px 20px',
              marginTop: '20px',
              borderRadius: '5px',
              backgroundColor: '#1F509A',
              color: '#fff',
              border: 'none',
            }}
          >
            Show More
          </button>
          </div>
        )}
       
      </div>
      <Footer />
    </>
  );
}

export default CitizenLogin;
